document.addEventListener('DOMContentLoaded', () => {
  const customWidthInput = document.getElementById('custom-width');
  const customLengthInput = document.getElementById('custom-length');
  const customPriceElement = document.getElementById('custom-price');
  const sizeErrorMessage = document.getElementById('size-error-message');
  const submitButton = document.getElementById('submit-custom-size');
  const addToCartText = document.getElementById('custom-add-to-cart');
  const loadingSpinner = document.getElementById('custom-loading-spinner');
  const customVariantIdInput = document.getElementById('custom-variant-id');
  const productIdInput = document.getElementById('product-id');
  const productTitleInput = document.getElementById('product-title');
  const productImageInput = document.getElementById('product-image');

const minSize = 2;
const maxSize = 15;
const maxSize2 = 10;
const basePrice = 34.90;
const incrementPrice = 35;

function isValidSize(width, length) {
  return (
    width >= minSize && width <= maxSize2 &&
    length >= minSize && length <= maxSize
  );
}

function updatePrice() {
  const width = parseInt(customWidthInput.value, 10);
  const length = parseInt(customLengthInput.value, 10);

  if (isValidSize(width, length)) {
    sizeErrorMessage.style.display = 'none';

    const additionalCost = (width - minSize + length - minSize) * incrementPrice;
    const totalPrice = basePrice + additionalCost;

    customPriceElement.textContent = `$${totalPrice.toFixed(2)}`;
  } else {
    sizeErrorMessage.style.display = 'block';
    customPriceElement.textContent = '$0';  
  }
}


  function isValidSize(width, length) {
    return width >= minSize && width <= maxSize2 && length >= minSize && length <= maxSize;
  }

  customWidthInput.addEventListener('input', updatePrice);
  customLengthInput.addEventListener('input', updatePrice);

  submitButton.addEventListener('click', (event) => {
    event.preventDefault();

    const width = parseInt(customWidthInput.value, 10);
    const length = parseInt(customLengthInput.value, 10);

    if (!isValidSize(width, length)) {
      sizeErrorMessage.style.display = 'block';
      return;
    }

    addToCartText.classList.add('hidden');
    loadingSpinner.classList.remove('hidden');

    const formData = new FormData();
    formData.append('custom_width', width);
    formData.append('custom_length', length);
    formData.append('product_id', productIdInput.value);
    formData.append('product_title', productTitleInput.value);
    formData.append('product_image', productImageInput.value);
    formData.append('custom_price', customPriceElement.textContent.replace('$', ''));

    fetch('https://solutions.solvertap.com/webhook/flashrug-custom-product-1dba55c3-e5b6-40f2-b520-bc84b27ab23c', {
      method: 'POST',
      body: JSON.stringify(Object.fromEntries(formData)),
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => response.text()) 
      .then(variantId => {
        console.log('Received Variant ID:', variantId);

        customVariantIdInput.value = variantId.trim(); 

        addToCart(variantId.trim());
      })
      .catch(error => {
        console.error('Error during webhook request:', error);
        showError();
      });
  });

  function addToCart(variantId) {
    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    const config = {
      method: 'POST',
      body: formData,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    };

    fetch('/cart/add.js', config)
      .then(response => response.json())
      .then(data => {
        console.log('Product added to cart:', data);
        window.location.href = '/cart';
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        showError();
      })
      .finally(() => {
        addToCartText.classList.remove('hidden');
        loadingSpinner.classList.add('hidden');
      });
  }

  function showError() {
    alert('Something went wrong. Please try again.');
    addToCartText.classList.remove('hidden');
    loadingSpinner.classList.add('hidden');
  }
});
  